import { useEffect, useMemo, useState } from 'react'
import { SimpleGrid, VStack } from '@chakra-ui/react'

import { APP_TIMEZONES, UTC_IANA } from '@common/timezones'

import { useTimezone } from '@contexts/TimezoneContext'

import { TimezoneCard } from './TimezoneCard'

type TimezoneCardConfig = {
    key: string
    label: string
    iana: string
    isLocal: boolean
    isAppTimezone: boolean
}

export function TimezoneSetting() {
    const { timezone, systemTimezone, updateTimezone, isOverridden } = useTimezone()
    const [now, setNow] = useState(() => new Date())

    useEffect(() => {
        const intervalId = window.setInterval(() => setNow(new Date()), 1000)

        return () => window.clearInterval(intervalId)
    }, [])

    const cards: TimezoneCardConfig[] = useMemo(
        () => [
            { key: 'local', label: 'LOCAL TIME', iana: systemTimezone, isLocal: true, isAppTimezone: false },
            {
                key: 'utc',
                label: 'UTC (SERVER TIME)',
                iana: UTC_IANA,
                isLocal: false,
                isAppTimezone: false,
            },
            ...APP_TIMEZONES.map(entry => ({
                key: entry.iana,
                label: entry.label.toUpperCase(),
                iana: entry.iana,
                isLocal: false,
                isAppTimezone: true,
            })),
        ],
        [systemTimezone],
    )

    return (
        <VStack align="stretch" spacing={6} w="100%">
            <SimpleGrid columns={{ base: 1, md: 2, lg: 3, xl: 5 }} spacing={4}>
                {cards.map(card => {
                    const isSelected = card.isLocal
                        ? timezone === systemTimezone
                        : isOverridden && timezone === card.iana

                    const matchesSystemTimezone = card.isAppTimezone && card.iana === systemTimezone

                    return (
                        <TimezoneCard
                            key={card.key}
                            label={card.label}
                            iana={card.iana}
                            isSelected={isSelected}
                            matchesSystemTimezone={matchesSystemTimezone}
                            now={now}
                            onSelect={() => (card.isLocal ? updateTimezone(systemTimezone) : updateTimezone(card.iana))}
                        />
                    )
                })}
            </SimpleGrid>
        </VStack>
    )
}
